import { render } from "./JudgeWelcome.vue?vue&type=template&id=34eb5e61"
import script from "./JudgeWelcome.vue?vue&type=script&lang=js"
export * from "./JudgeWelcome.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__